// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z6dd","importantInfo":"styles_importantInfo__2TjAC"};